import { Injectable, inject } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { ContextMembership, FirestoreUser, IFirestoreUser, NetworkConstants, Person } from 'diwimamodelweb/lib';
import { diffObject, updatesToFirestoreUpdates } from 'diwimamodelweb/lib/utils/obejct-diff'
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { map, skipWhile, take, takeUntil } from 'rxjs/operators';
import { EventInviteSharedService } from '../cockpit/event-invitation/event-invite-shared.service';
import { SettingsService } from './settings.service';
import { TransactionLogService } from './transaction-log.service';
import { UserService } from './user.service';
import { deepCopy, removeUndefined } from 'diwimamodelweb/lib';
import { deleteField } from 'firebase/firestore';
import { Firestore, collection, collectionData, deleteDoc, doc, query, setDoc, updateDoc, where } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class PersonService {
  private Ifirestore = inject(Firestore);
  ngUnsubscribe: Subject<void> = new Subject<void>();

  // subPerson: any|undefined = undefined
  subscriptions: Map<string, Subscription> = new Map([])
  personSubject$ = new BehaviorSubject<Person[]>(undefined)
  subbedContext: string|undefined = undefined

  constructor(
    private firestore: AngularFirestore,
    private transactionLogService: TransactionLogService,
    private userService: UserService,
    private settingsService: SettingsService,
    private functions: AngularFireFunctions,
    private eventInviteSharedService: EventInviteSharedService
  ) {
    // this.settingsService.selectedUserContext$.pipe(
    //   // skipWhile(el => !el),
    //   // map(el => el.identifier)
    // ).subscribe((context) => {
    //   if (!context) {
    //     this.subbedContext = undefined
    //     return 
    //   }
    //   if (this.subbedContext?.identifier == context.identifier) {
    //     return
    //   }
    //   this.personSubject$.next(undefined)
    //   if (this.subscriptions.get('1')) this.subscriptions.get('1').unsubscribe()
    //   const sub = this.observePerson(context.identifier)
    //   this.subscriptions.set('1', sub)
    //   this.subbedContext = context
    // })
  }

  observeData(contextId) {
    if (this.subbedContext == contextId) return 
    if (this.subscriptions.get('1')) this.subscriptions.get('1').unsubscribe()
    if (!!this.personSubject$.value) this.personSubject$.next(undefined)
    const sub = this.observePerson(contextId)
    this.subscriptions.set('1', sub)
    this.subbedContext = contextId
  }

  async removeSubs(): Promise<void> {
    this.ngUnsubscribe.next()
    this.subbedContext = undefined
    this.subscriptions.forEach((value) => {
      value.unsubscribe()
    })
    this.resetData()
    return Promise.resolve()
  }

  resetData() {
    this.personSubject$.next(null)
  }
  
  async updatePerson(oldPerson, newPerson): Promise<void> {
    return new Promise(async (resolve, reject) => {
      const updates = diffObject(oldPerson, newPerson, {})
      const map = updatesToFirestoreUpdates(updates)
      try {
        const user = await this.userService.user$.pipe(take(1)).toPromise()
        const list = await this.transactionLogService.determineDiff(user, updates, newPerson.identifier, NetworkConstants.COLLECTION_PERSON)
        map['updateTimestamp'] = new Date()
        const docRef = doc(this.Ifirestore, NetworkConstants.COLLECTION_PERSON, newPerson.identifier)
        await updateDoc( docRef, map)
        // await this.firestore.collection(NetworkConstants.COLLECTION_PERSON).doc(newPerson.identifier).update(map)
        // if successfull save transactionlog..
         await this.transactionLogService.saveTransactionLog(list)
         resolve()
      } catch (error) {
        reject(error)
      }
    })

  }

  async createPerson(newPerson: any): Promise<void> {
    return new Promise(async (resolve, reject) => {
      // const docRef = this.firestore.collection(NetworkConstants.COLLECTION_PERSON).doc().ref
      const docRef = doc(collection(this.Ifirestore, NetworkConstants.COLLECTION_PERSON))
      const now = new Date()
      newPerson['identifier'] = docRef.id
      newPerson['creationDate'] = now
      newPerson['updateTimestamp'] = now
      try {
        const contextId = this.settingsService.selectedUserContext$.value.identifier
        if (!contextId) reject("No context id")
        const user = await this.userService.user$.pipe(take(1)).toPromise()
        const logItems = this.transactionLogService.createLog(user, newPerson.identifier, NetworkConstants.COLLECTION_PERSON, newPerson)
        newPerson['contextId'] = contextId
        // await this.firestore.collection(NetworkConstants.COLLECTION_PERSON).doc(newPerson.identifier).set({...newPerson})
        await setDoc(docRef,{...newPerson} )

        await this.transactionLogService.saveTransactionLog(logItems)
        resolve()
      } catch (error) {
        console.error(error)
        reject(error)
      }
    })
  }

  deletePerson(person: Person): Promise<void> {
    return new Promise(async (resolve, reject) => {
      const personToDelete = deepCopy(person, person.replacerFn)
      const dataToDelete = removeUndefined(personToDelete)
      const user = await this.userService.user$.pipe(take(1)).toPromise()
      const transactionLogItem = this.transactionLogService.deleteDocumentLog(
        user,
        person.identifier,
        NetworkConstants.COLLECTION_PERSON,
        dataToDelete
      )
      const promiseArray = []
      promiseArray.push(
        this.transactionLogService.saveTransactionLog([transactionLogItem])
      )
      // const delOperation = this.firestore.collection(NetworkConstants.COLLECTION_PERSON).doc(person.identifier).delete()
      const docRef = doc(this.Ifirestore, NetworkConstants.COLLECTION_PERSON, person.identifier)
        const delOperation = await deleteDoc( docRef)
      promiseArray.push(delOperation)
      try {
        await Promise.all(promiseArray)
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }

  observePerson(contextId: string) {
    // if (this.subPerson) return 
    // return this.firestore.collection(NetworkConstants.COLLECTION_PERSON, ref => ref.where('contextId', "==", contextId)).valueChanges()
    const path = `${NetworkConstants.COLLECTION_PERSON}`
    const collRef = collection(this.Ifirestore, path);
    const q = query(collRef, where('contextId', '==', contextId))

    return collectionData(q)
      .pipe(
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((values: any[]) => {
        // values to person 
        var list: Person[] = []
        values.forEach((element) => {
          const person = new Person()
          person.setFromAny(element)
          list.push(person)
        })
        this.personSubject$.next(list)
      })
  }

  addUserToContext(newUser: IFirestoreUser): Promise<void> {
    return new Promise(async (resolve, reject) => {
      try {
        const contextId = this.settingsService.selectedUserContext$.value.identifier
        if (!contextId) reject("No contextId!")
        const user = await this.userService.user$.pipe(take(1)).toPromise()
        const context = this.settingsService.selectedUserContext$.value
        newUser.contextId = context.identifier
        const callable = this.functions.httpsCallable('createUser')
        const reply: any = await callable(newUser).toPromise()
        const logItems = this.transactionLogService.createLog(user, reply.userID, NetworkConstants.COLLECTION_USER, newUser)
        await this.transactionLogService.saveTransactionLog(logItems)
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }

  updateExistingUser(oldUser: FirestoreUser, newUser: FirestoreUser): Promise<void> {
    return new Promise(async (resolve, reject) => {
      const updates = diffObject(oldUser, newUser, {})
      const map = deepCopy(updates)
      for (let [key, value] of Object.entries(map)) {
        const {newValue} = value as any
        map[key] = newValue ? newValue : deleteField()
    }

      // const changes = updatesToFirestoreUpdates(updates)
      try {
        const user = await this.userService.user$.pipe(take(1)).toPromise()
        const list = await this.transactionLogService.determineDiff(user, updates, newUser.identifier, NetworkConstants.COLLECTION_USER)
        // save user data ...
        map.updateTimestamp = new Date()
        const docRef = doc(this.Ifirestore, NetworkConstants.COLLECTION_USER, newUser.identifier)
        await updateDoc( docRef, map)
        // save transactionlog data...
        await this.transactionLogService.saveTransactionLog(list)
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }


  updateExistingUserContextMembership(oldUser: FirestoreUser, newUser: FirestoreUser, contextMembershipId, userId): Promise<void> {
    return new Promise(async (resolve, reject) => {
      const updates = diffObject(oldUser, newUser, {})
      const map = deepCopy(updates)
      for (let [key, value] of Object.entries(map)) {
        const {newValue} = value as any
        map[key] = newValue ? newValue : deleteField()
    }
      // const map = updatesToFirestoreUpdates(updates)
      // for backward comp: keep updating COLLECTION_CONTEXT_MEMBERSHIP
      try {
        const user = await this.userService.user$.pipe(take(1)).toPromise()
        const list = await this.transactionLogService.determineDiff(user, updates, newUser.identifier, `${NetworkConstants.COLLECTION_USER}/${userId}/${NetworkConstants.COLLECTION_CONTEXT_MEMBERSHIP}/${contextMembershipId}`)
        // save user data ...
        map.updateTimestamp = new Date()
        const docRef = doc(this.Ifirestore, NetworkConstants.COLLECTION_USER, userId, NetworkConstants.COLLECTION_CONTEXT_MEMBERSHIP, contextMembershipId)
        await updateDoc( docRef, map)
        // save transactionlog data...
        await this.transactionLogService.saveTransactionLog(list)
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }

}
